import { React } from "react";
import { connect } from "react-redux";

// @material-ui/core components
import {
  Container,
} from "@material-ui/core";

//import custom components
import FollowUpFeedbackReports from "../../../Components/OpportunityApplicationsFollowUp/FollowUpFeedbackReports";

function FollowUpFeedbackReportsTab(props) {
  return (
    <>
      <Container maxWidth={false}>
        <FollowUpFeedbackReports
            opportunityApplicationFollowUpDetails={props.opportunityApplicationFollowUpDetails}
            isUserColective={false}
            handleRefreshPage={props.handleRefreshPage}
        />
      </Container>
    </>
  );
}

const mapStateToProps = (state) => ({ ...state });

export default connect(mapStateToProps)(FollowUpFeedbackReportsTab);